$shm_tree $mol_list
	roots? /
	children*? /
	expanded*? true
	expanded_state*? true
	expanded_default* true
	expanded_key* \
	indent 24
	Item* $mol_view
		sub / <= id* \
	Guide* $mol_view
	rows <= visible_rows /
	Row* $mol_view
		sub /
			<= Guides* $mol_view
				sub <= guide_rows* /
			<= Toggle* $mol_check_expand
				style *
					^
					left <= toggle_left* \0px
				checked? <=> expanded*? true
			<= Content* $mol_view
				style *
					^
					marginLeft <= content_left* \0px
				sub / <= Item*
